import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { Profile } from '@atlaskit/atlassian-navigation';
import { NAVIGATION_CHANNEL } from '../../analytics';
import { SignInIcon } from '../icons/sign-in';
export var AccountMenuLoggedOutState = function AccountMenuLoggedOutState(_ref) {
  var testId = _ref.testId,
    logInLink = _ref.logInLink;
  return /*#__PURE__*/React.createElement(Profile, {
    testId: testId,
    href: logInLink,
    onClick: function onClick(event, analytics) {
      analytics.update({
        actionSubjectId: 'logInLink'
      }).fire(NAVIGATION_CHANNEL);
    },
    tooltip: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "identity.account-menu.account-menu-logged-out-state.log-in",
      defaultMessage: "Log in",
      description: "Tooltip for log in button when user is logged out"
    }),
    icon: /*#__PURE__*/React.createElement(SignInIcon, {
      label: "",
      size: "medium"
    })
  });
};